import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export const offerStatusQueryKeys = {
  all: ['offers', 'statuses'] as const,
  list: (offerIds: Array<string>) => [...offerStatusQueryKeys.all, offerIds] as const,
};

export function useGetOfferStatuses(offerIds: Array<string>, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: offerStatusQueryKeys.list(offerIds),
    queryFn: async (): Promise<Record<string, string | null>> => {
      const { result } = await OffersService.getOfferStatuses(offerIds);
      return result;
    },
    enabled: (options?.enabled ?? true) && offerIds.length > 0,
  });
}
